import { render } from "./DownloadTemplateModal.vue?vue&type=template&id=d98992b8"
import script from "./DownloadTemplateModal.vue?vue&type=script&lang=js"
export * from "./DownloadTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__